<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"/>
    </div>
    <b-row>
      <b-col cols="12">
        <b-card>
          <h3
            class="f-g text-center"
          >Período analisado: {{moment(datainicial).format("DD/MM/YYYY")}} a {{moment(datafinal).format("DD/MM/YYYY")}}, com {{qtdCampanhas}} campanhas.</h3>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card header="Envios de Push">
          <b-table
            bordered
            responsive="sm"
            :items="items_detalhamento_envio"
            thead-class="hidden_header"
          ></b-table>
        </b-card>
      </b-col>
      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card header="Gráfico - Envios de Push">
          <envios-de-push
            v-if="readyToShow"
            :enviadas="enviadas"
            :rejeitadas="rejeitadas"
            :height="185"
          ></envios-de-push>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card header="Visualizações e compras">
          <b-table
            bordered
            responsive="sm"
            :items="items_visualizacoes_compras"
            thead-class="hidden_header"
          ></b-table>
        </b-card>
      </b-col>
      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card header="Gráfico - Visualizações e compras">
          <visualizacoes-compras
            v-if="readyToShow"
            :recebidas="enviadas"
            :visualizadas="visualizadas"
            :compraram="compraram"
            :height="185"
          ></visualizacoes-compras>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card header="Clientes no período">
          <b-table
            bordered
            responsive="sm"
            :items="items_clientes_periodo"
            thead-class="hidden_header"
          ></b-table>
        </b-card>
      </b-col>
      <b-col xl="6" lg="6" md="6" sm="12">
        <b-card header="Gráfico - Clientes no período">
          <clientes-no-periodo
            v-if="readyToShow"
            :identificados="clientes_identificados"
            :naoidentificados="clientes_nao_identificados"
            :compraram="compraram"
            :height="185"
          ></clientes-no-periodo>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card header="Clientes no período">
          <visualizacoes-compras-line
            v-if="readyToShow"
            :labels="datasetLabels"
            :identificados="datasetIdentificados"
            :naoidentificados="datasetNaoIdentificados"
            :fidelizados="datasetFidelizados"
          ></visualizacoes-compras-line>
        </b-card>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col cols="12">
        <b-card header="Resultados">
          <b-row>
            <b-col xl="6" lg="6" md="6" sm="12">
              <b-table
                bordered
                responsive="sm"
                :items="items_resultados"
                thead-class="hidden_header"
              ></b-table>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="12">
              <div class="text-center">
                <p>Para cada 1 real investido, foi gerado</p>
                <h2>R${{faturado}}</h2>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>-->
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import moment from "moment";
import axios from "axios";
import * as config from "@/config.json";
import EnviosDePush from "../charts/EnviosDePush";
import VisualizacoesCompras from "../charts/VisualizacoesCompras";
import ClientesNoPeriodo from "../charts/ClientesNoPeriodo";
import VisualizacoesComprasLine from "../charts/VisualizacoesComprasLine";

export default {
  components: {
    Loading,
    moment,
    EnviosDePush,
    VisualizacoesCompras,
    ClientesNoPeriodo,
    VisualizacoesComprasLine
  },
  data: () => {
    return {
      isLoading: false,
      datainicial: null,
      datafinal: null,
      items_detalhamento_envio: null,
      items_visualizacoes_compras: null,
      items_clientes_periodo: null,
      enviadas: null,
      rejeitadas: null,
      visualizadas: null,
      compraram: null,
      readyToShow: false,
      clientes_identificados: null,
      clientes_nao_identificados: null,
      datasetLabels: null,
      datasetIdentificados: null,
      datasetNaoIdentificados: null,
      datasetFidelizados: null,
      items_resultados: null,
      faturado: null,
      qtdCampanhas: null
    };
  },
  async beforeMount() {
    this.isLoading = true;

    this.datainicial = moment(localStorage.getItem("datainicial")).format(
      "YYYY-MM-DD"
    );
    this.datafinal = moment(localStorage.getItem("datafinal")).format(
      "YYYY-MM-DD"
    );

    this.qtdCampanhas = localStorage.getItem("qtdCampanhas");

    await axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-totalizador-campanhas/${localStorage
          .getItem("enterprise_id")
          .toString()}/${this.datainicial}/${this.datafinal}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        if (response.status == 200)
          if (response.data) {
            this.visualizadas = response.data.pushsvisualizados;
            if (response.data.detalhamento_envio) {
              this.items_detalhamento_envio = response.data.detalhamento_envio;
              for (let i = 0; i < this.items_detalhamento_envio.length; i++) {
                const e = this.items_detalhamento_envio[i];
                if (e.descricao == "Enviadas") this.enviadas = e.valor;
                if (e.descricao == "Rejeitadas") this.rejeitadas = e.valor;
              }
            } else this.items_detalhamento_envio = [];
          }
      });

    await axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-clientes-que-compraram/${localStorage
          .getItem("enterprise_id")
          .toString()}/${this.datainicial}/${this.datafinal}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        if (response.status == 200)
          if (response.data.data) {
            var arr = [];
            this.compraram = response.data.data.qtd;
            arr.push({ descricao: "Recebidos", valor: this.enviadas });
            arr.push({ descricao: "Visualizados", valor: this.visualizadas });
            arr.push({ descricao: "Compras", valor: this.compraram });
            arr.push({
              descricao: "Taxa de conversão",
              valor: `${parseFloat(
                (this.compraram * 100) / this.enviadas
              ).toFixed(2)}%`
            });
            this.items_visualizacoes_compras = arr;
            this.items_clientes_periodo = [];
            this.clientes_identificados = response.data.data.sim.qtd;
            this.clientes_nao_identificados = response.data.data.nao.qtd;
            this.items_clientes_periodo.push({
              descricao: "Identificados",
              valor: this.clientes_identificados
            });
            this.items_clientes_periodo.push({
              descricao: "Não identificados",
              valor: this.clientes_nao_identificados
            });
            this.items_clientes_periodo.push({
              descricao: "Compras",
              valor: this.compraram
            });
            this.items_clientes_periodo.push({
              descricao: "Taxa de impacto",
              valor: `${parseFloat(
                (this.compraram * 100) / this.clientes_identificados
              ).toFixed(2)}%`
            });
          } else this.items_visualizacoes_compras = [];
      });
    await axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-dataset-clientes/${localStorage
          .getItem("enterprise_id")
          .toString()}/${this.datainicial}/${this.datafinal}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        if (response.status == 200) {
          if (response.data.data) {
            const e = response.data.data;
            this.datasetLabels = e.labels;
            this.datasetIdentificados = e.identificados;
            this.datasetNaoIdentificados = e.naoidentificados;
            this.datasetFidelizados = e.fidelizados;
          }
        }
      });
    await axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-resultados/${localStorage
          .getItem("enterprise_id")
          .toString()}/${this.datainicial}/${this.datafinal}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        if (response.status == 200) {
          if (response.data.data) {
            const e = response.data.data;
            this.faturado = e.total.toFixed(2);
            this.items_resultados = [
              { descricao: "Compras geradas", valor: e.qtd },
              { descricao: "Ticket médio", valor: `R$${e.ticket.toFixed(2)}` },
              { descricao: "Total faturado", valor: `R$${this.faturado}` }
            ];
          }
        }
      });

    this.readyToShow = true;
    this.isLoading = false;
  }
};
</script>
